module.exports = __webpack_public_path__ + "img/contentImgHover5.b1457b7.webp";